import { createMetaPlatformRequest } from '@/services/request';
import { normalizePageParams } from './pagination';
import type {
  TaxonomyListResult,
  TaxonomyQuery,
  TaxonomyRequestOptions,
  TaxonomyTreeResult,
} from './types/taxonomy';

const request = createMetaPlatformRequest();

export async function queryTaxonomies(
  params: TaxonomyQuery,
  options?: TaxonomyRequestOptions,
) {
  return request<TaxonomyListResult>('/bff/public/taxonomy', {
    method: 'GET',
    params: normalizePageParams(params),
    ...(options || {}),
  });
}

export async function getTaxonomyTreeByUuid(
  uuid: string,
  options?: TaxonomyRequestOptions,
) {
  return request<TaxonomyTreeResult>(`/bff/public/taxonomy/uuid/${uuid}/tree`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function getTaxonomyTreeByIdentifier(
  identifier: string,
  options?: TaxonomyRequestOptions,
) {
  return request<TaxonomyTreeResult>(
    `/bff/public/taxonomy/identifier/${identifier}/tree`,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}
